import { useTranslation } from "react-i18next";

const brands = [
  "Toyota", "Ford", "Isuzu", "Mitsubishi", "Mazda", "Nissan",
  "Holden", "Hyundai", "Kia", "Volkswagen", "Land Rover", "Jeep",
];

export default function BrandStrip() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-white py-10">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <p className="text-center text-xs font-medium uppercase tracking-widest text-neutral-400">
          {t("brand.strip")}
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {brands.map((b) => (
            <span
              key={b}
              className="rounded-md border border-neutral-200 bg-neutral-50 px-4 py-2 text-sm font-semibold text-neutral-700"
            >
              {b}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}